"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGenerateCurrencies = void 0;
var useCurrencies_1 = require("./useCurrencies");
var react_1 = require("react");
var useConfig_1 = require("../useConfig");
var useGenerateCurrencies = function () {
    var currencies = (0, useCurrencies_1.useCurrencies)();
    var config = (0, useConfig_1.useConfig)();
    return (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d, _e, _f;
        if (!((_a = config === null || config === void 0 ? void 0 : config.currencies) === null || _a === void 0 ? void 0 : _a['list']) ||
            ((_c = (_b = config === null || config === void 0 ? void 0 : config.currencies) === null || _b === void 0 ? void 0 : _b['list']) === null || _c === void 0 ? void 0 : _c.length) === 0)
            return (((_d = currencies === null || currencies === void 0 ? void 0 : currencies.data) === null || _d === void 0 ? void 0 : _d.map(function (item) { return ({
                label: item.code,
                value: item.code,
            }); })) || []);
        return (_f = (((_e = config === null || config === void 0 ? void 0 : config.currencies) === null || _e === void 0 ? void 0 : _e['list']) || [])) === null || _f === void 0 ? void 0 : _f.map(function (item) { return ({
            label: item,
            value: item,
        }); });
    }, [currencies, config === null || config === void 0 ? void 0 : config.currencies]);
};
exports.useGenerateCurrencies = useGenerateCurrencies;
